import { t } from 'i18next'
import * as ClaimService from '../../Services/claim-service';
import { useState } from 'react';
import { ClaimRequestSearch } from './claim-request-search';
import { ClaimRequestInsuredInfo } from './claim-request-insured-info';
import _ from 'lodash';
import { ClaimRequestBenefitInfo } from './claim-request-benefit-info';
import ClaimRequestPaymentMethod from './claim-request-payment-method';
import ClaimRequestOther from './claim-request-other';
import ClaimRequestUploadFile from './claim-request-upload-file';
import ClaimRequestTermSubmit from './claim-request-term-submit';
import { CircularProgress } from "@mui/material";
import { CustomDialog } from '../../Components/custom-dialog/custom-dialog';
import useWindowDimensions from '../../Layouts/useWindowDimension';
import ImageBackground from '../../Assets/Images/background-contnt.png'
import CustomNav from '../../Components/custom-nav/CustomNav';
import FooterCustomer from '../../Layouts/footer/FooterCustomer';
import '../../Assets/Styles/Claim/claim-request.css';
import { countTimeExpired } from '../../Services/service';

function ClaimRequest() {
    // const [objectDto, setObjectDto] = useState(sessionStorage.getItem("objectDto") !== null && sessionStorage.getItem("objectDto") !== "undefined" ?
    //     JSON.parse(sessionStorage.getItem("objectDto")) : {});
    const [objectLocal, setObjectLocal] = useState(JSON.parse(localStorage.getItem('aaa')));
    const [objectDto, setObjectDto] = useState(sessionStorage.getItem("objectDto") !== null && sessionStorage.getItem("objectDto") !== "undefined" ?
        JSON.parse(sessionStorage.getItem("objectDto")) : { "checked": 0, "policyChecked": 0 });
    const [loading, setLoading] = useState(false);
    const [validate, setValidate] = useState(false);
    const [term, setTerm] = useState(false);
    const [counter, setCounter] = useState(0);
    const [listFile, setListFile] = useState([]);
    const [activeItem, setActiveItem] = useState({ title: t("settlementofinsurancebenefitcustomer"), icon: <i class="fa fa-database" aria-hidden="true"></i>, no: 3 });
    const [open, setOpen] = useState(false);
    countTimeExpired(setObjectDto);
    const handleClose = () => {
        setOpen(false);
    };
    const { height, width } = useWindowDimensions();
    const divStyle = {
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    ClaimService.ManageClaimRequest(objectDto, setObjectDto);
    return (
        <>
            <CustomDialog description={objectDto !== undefined ? objectDto.strMsgADD || "" + "\n" + objectDto.strMsgHI || "" : ""} handleClose={handleClose} open={open} objectDto={objectDto} setLoading={setLoading} setObjectDto={setObjectDto} setValidate={setValidate} />
            <div className='nav-container' style={{ height: height }}>
                <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectLocal} setObjectDto={setObjectLocal} width={width} height={height} />
                <div className="claim-request-background" style={divStyle}>
                    <section className="claim-info-container">
                        <div id="id-claim-main">
                            <div className="row">
                                <div className="col-sm-12 col-xs-12 col-md-12">
                                    <label className="title-head-claim header-title-customer" style={{ textAlign: "center" }}>{t('claimregister').toUpperCase()}</label>
                                </div>
                                <div className="col-sm-12 col-xs-12 col-md-12 description-head-claim" style={{}}>
                                    <label className='description-small-customer' >
                                        <span>{t("claimregistercomments1")}</span>
                                        <span style={{ fontWeight: "bold" }}>
                                            <i>{t("claimregistercomments2")}</i>
                                        </span>
                                        <span>{" "}{t("claimregistercomments3")}{" "}
                                        </span>
                                        <span style={{ fontWeight: "bold" }}>
                                            <i>{t("claimregistercomments4")}</i>
                                        </span>
                                        <span>{t("claimregistercomments5")}</span>
                                    </label>
                                </div>
                            </div>
                            {
                                objectDto !== undefined && objectDto !== null && objectDto !== '' && !_.isEmpty(objectDto) ?
                                    <>
                                        <ClaimRequestSearch objectDto={objectDto} setLoading={setLoading} setObjectDto={setObjectDto} validate={validate} setCounter={setCounter} counter={counter} />
                                        <ClaimRequestInsuredInfo objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} validate={validate} />
                                        <ClaimRequestBenefitInfo objectDto={objectDto} setObjectDto={setObjectDto} validate={validate} />
                                        <ClaimRequestPaymentMethod objectDto={objectDto} setObjectDto={setObjectDto} validate={validate} />
                                        <ClaimRequestOther objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} validate={validate} />
                                        <ClaimRequestUploadFile objectDto={objectDto} setLoading={setLoading} setObjectDto={setObjectDto} listFile={listFile} setListFile={setListFile} validate={validate} />
                                        <ClaimRequestTermSubmit objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} setTerm={setTerm} term={term} setValidate={setValidate} listFile={listFile} setOpen={setOpen} />
                                    </>
                                    :
                                    <div style={{ textAlign: "center", paddingTop: "120px" }}>
                                        <h3 style={{ color: "red", fontWeight: "bold" }}>{t("erroraccesspage").toUpperCase() + " "}<a style={{ "color": "#c4960c" }} href="/" >Về trang chủ</a></h3>
                                        <CircularProgress style={{ color: "red", marginTop: "50px" }} />
                                    </div>
                            }
                        </div>
                    </section>
                </div>
            </div>
            <FooterCustomer />
        </>
    )
}
export default ClaimRequest